import { graphql } from 'src/gql'
import { SortFindManyContract_VehicleInput } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQLDropdownOptions } from 'src/queries/cat/lookups/helpers'

const document = graphql(/* graphql */`
  query contractVehicles($sort: SortFindManyContract_VehicleInput) {
    lookups {
      Contract_Vehicle {
        many(sort: $sort) {
          _id
          name
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type ContractVehicles = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['Contract_Vehicle']>['many']>

const useContractVehicles = useGraphQLDropdownOptions(
  document,
  'lookups.Contract_Vehicle.many',
  { sort: SortFindManyContract_VehicleInput.NameAsc }
)

export { useContractVehicles, document as contractVehiclesDocument }
